<ng-container *transloco="let t">
    <div
        class="no-data-found flex flex-col items-center justify-center rounded-2xl border border-dashed px-8 py-16 text-center shadow-sm bg-card border-gray-300 dark:border-gray-600"
        [class.no-data-found--compact]="compact"
        role="status"
        aria-live="polite"
    >
        @if (!compact) {
            <div class="flex h-20 w-20 items-center justify-center rounded-full text-primary">
                <mat-icon class="icon-size-12 text-primary" [svgIcon]="icon"></mat-icon>
            </div>
        } @else {
            <div class="no-data-found__icon-compact flex h-16 w-16 items-center justify-center rounded-full text-primary mb-2">
                <mat-icon class="icon-size-10 text-primary" [svgIcon]="icon"></mat-icon>
            </div>
        }
        <h3 class="text-xl font-semibold tracking-tight text-default mb-2">
            {{ title ?? t(titleKey) }}
        </h3>
        @if (message || messageKey) {
            <p class="text-secondary max-w-md text-sm leading-relaxed">
                {{ message ?? t(messageKey!) }}
            </p>
        }
        @if (hasAction) {
            <button mat-flat-button class="bg-primary text-white px-6 mt-6 gap-1" type="button" (click)="onActionClick()">
                @if (actionIcon) {
                    <mat-icon class="icon-size-5 me-2" [svgIcon]="actionIcon"></mat-icon>
                }
                <span>{{ actionLabel ?? t(actionLabelKey!) }}</span>
            </button>
        }
        <ng-content></ng-content>
    </div>
</ng-container>
